import { base_url } from "..";
import axios from "axios";

function getMethod(url: string) {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(`${base_url}/${url}`);
      const data = res.data;
      return resolve(data);
    } catch (err) {
      reject(err);
    }
  });

  return promise;
}

function postMethod(url: string, data: any) {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(`${base_url}/${url}`, data, {
        headers: {
          "Content-Type": "Application/json",
        },
      });
      const result = res.data;
      return resolve(result);
    } catch (err) {
      reject(err);
    }
  });

  return promise;
}

function putMethod(url: string, data: any) {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(`${base_url}/${url}`, data, {
        headers: {
          "Content-Type": "Application/json",
        },
      });
      const result = res.data;
      return resolve(result);
    } catch (err) {
      reject(err);
    }
  });

  return promise;
}

function deleteMethod(url: string) {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await axios.delete(`${base_url}/${url}`);
      const result = res.data;
      return resolve(result);
    } catch (err) {
      reject(err);
    }
  });

  return promise;
}

const API = {
  getMethod,
  postMethod,
  putMethod,
  deleteMethod,
};

export default API;
